import React from 'react';

const textLight = (props) => {
    return (
        <h5 className={`u-flex align-items-center u-fontWeightRegular u-fontSize13 u-textColorLight`}>{props.children}</h5>
    );
}

export default textLight;


// WEBPACK FOOTER //
// ./src/components/Flight/FlightDetailsRoundTrip/TextLight/TextLight.js